export var EASYBIB = 'easybib';
export var BIBME = 'bibme';
export var CITATION_MACHINE = 'citationmachine';
export var CHEGG = 'chegg';
export var CHEGG_NET = 'cheggnet';
export var CHEGG_SIHP = 'cheggsihp';
export var OWL = 'owl';
export var CITE_THIS_FOR_ME = 'citethisforme';
export var BUSINESS_UNIT = 'wt';
export var GRAMMAR = 'grammar';
export var PLAGIARISM = 'plagiarism';
export var EXPERT_CHECK = 'expert-check';
export var LEFT = 'left';
export var RIGHT = 'right';
export var CENTER = 'center';